{
  "home": {
    "tagline": "Over 1 million hundeejere træner med Hundeo",
    "subline": "Anbefalet af rigtige hundetrænere",
    "appStorePrefix": "Hent i",
    "playStorePrefix": "Hent på",
    "qrHint": "Åbn appen på din telefon",
    "qrCaption": "Scan koden med kameraet",
    "socialProof": "5.000+ femstjernede anmeldelser",
    "imprint": "Imprint",
    "privacy": "Privatliv",
    "language": "Sprog",
    "openWebsite": "Til websiden",
    "openInApp": "Åbn i Hundeo-appen",
    "openInAppHint": "Du sendes videre til din app",
    "openInAppButton": "Åbn",
    "promoRedirectTitle": "Dit tilbud åbnes …",
    "promoRedirectButton": "Gå til dit tilbud"
  }
}
